var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AnswersView',{attrs:{"snapshot":_vm.snapshotFields,"answers":_vm.formData,"alarms-only":_vm.showAlarmsOnly,"collapsible":true,"start-collapsed":false,"show-comments":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }